<script>
import Sellingchart from "./sellingchart";

export default {
  components: {
    Sellingchart,
  },
  data() {
    return {
      products: [
        {
          title: "Produto Testes 001",
          amount: "R$ 638.000,00",
          revenue: "0.6",
          list: [
            {
              name: "Produto Testes 002",
              text: "descrição auxiliar produto",
              sales: 37,
              color: "#556ee6",
            },
            {
              name: "Produto Testes 999",
              text: "descrição auxiliar produto",
              sales: 72,
              color: "#34c38f",
            },
            {
              name: "Produto Testes 888",
              text: "descrição auxiliar produto",
              sales: 54,
              color: "#f46a6a",
            },
          ],
        },
      ],
    };
  },
  methods: {
    productSelling(event) {
      switch (event.target.value) {
        case "marco":
          this.products = [
            {
              title: "Produto Testes 001",
              amount: "R$ 784.285,00",
              revenue: "0.4",
              list: [
                {
                  name: "Produto Testes 099",
                  text: "Neque quis est",
                  sales: 41,
                  color: "#f46a6a",
                },
                {
                  name: "Produto Testes 055",
                  text: "Quis autem iure",
                  sales: 14,
                  color: "#556ee6",
                },
                {
                  name: "Produto Testes 987",
                  text: "Sed aliquam mauris.",
                  sales: 85,
                  color: "#34c38f",
                },
              ],
            },
          ];
          break;
        case "fevereiro":
          this.products = [
            {
              title: "Produto Testes 002",
              amount: "R$ 638.855,00",
              revenue: "0.6",
              list: [
                {
                  name: "Produto Testes 002",
                  text: "Neque quis est",
                  sales: 37,
                  color: "#556ee6",
                },
                {
                  name: "Produto Testes 001",
                  text: "Quis autem iure",
                  sales: 72,
                  color: "#f46a6a",
                },
                {
                  name: "Produto Testes 888",
                  text: "Sed aliquam mauris.",
                  sales: 54,
                  color: "#34c38f",
                },
              ],
            },
          ];
          break;
        case "janeiro":
          this.products = [
            {
              title: "Produto Testes 888",
              amount: "R$ 474.000,55",
              revenue: "0.8",
              list: [
                {
                  name: "Produto Testes 077",
                  text: "Neque quis est",
                  sales: 31,
                  color: "#34c38f",
                },
                {
                  name: "Produto Testes 444",
                  text: "Quis autem iure",
                  sales: 20,
                  color: "#556ee6",
                },
                {
                  name: "Produto Testes 005",
                  text: "Sed aliquam mauris.",
                  sales: 40,
                  color: "#f46a6a",
                },
              ],
            },
          ];
          break;
        case "dezembro":
          this.products = [
            {
              title: "Produto Testes 099",
              amount: "R$ 874.500,00",
              revenue: "0.4",
              list: [
                {
                  name: "Produto Testes 005",
                  text: "Neque quis est",
                  sales: 41,
                  color: "#f46a6a",
                },
                {
                  name: "Produto Testes 999",
                  text: "Quis autem iure",
                  sales: 74,
                  color: "#34c38f",
                },
                {
                  name: "Produto Testes 006",
                  text: "Sed aliquam mauris.",
                  sales: 52,
                  color: "#556ee6",
                },
              ],
            },
          ];
          break;
        default:
          this.products = [
            {
              title: "Produto Testes 002",
              amount: "R$ 638.500,00",
              revenue: "0.6",
              list: [
                {
                  name: "Produto Testes 002",
                  text: "Neque quis est",
                  sales: 37,
                },
                {
                  name: "Produto Testes 001",
                  text: "Quis autem iure",
                  sales: 72,
                },
                {
                  name: "Produto Testes 888",
                  text: "Sed aliquam mauris.",
                  sales: 54,
                },
              ],
            },
          ];
          break;
      }
    },
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="clearfix">
        <div class="float-end">
          <div class="input-group input-group-sm">
            <select
              id="selectProdDestaqDash02"
              class="form-select form-select-sm"
              @click="productSelling($event)"
            >
              <option value="marco" selected>Mar</option>
              <option value="fevereiro">Fev</option>
              <option value="janeiro">Jan</option>
              <option value="dezembro">Dez</option>
            </select>
            <label class="input-group-text" for="selectProdDestaqDash02">Mês</label>
          </div>
        </div>
        <h4 class="card-title mb-4">Produtos em Destaque</h4>
      </div>
      <div v-for="(data, index) of products" :key="index">
        <div class="text-muted text-center">
          <p class="mb-2">{{ data.title }}</p>
          <h4>{{ data.amount }}</h4>
          <p class="mt-4 mb-0">
            <span class="badge badge-soft-success font-size-11 me-2">
              {{ data.revenue }}% <i class="mdi mdi-arrow-up"></i>
            </span>
            do período anterior
          </p>
        </div>

        <div class="table-responsive mt-4">
          <table class="table align-middle mb-0">
            <tbody>
              <tr v-for="(item, index) of data.list" :key="index">
                <td>
                  <h5 class="font-size-14 mb-1">{{ item.name }}</h5>
                  <p class="text-muted mb-0">{{ item.text }}</p>
                </td>
                <td>
                  <Sellingchart
                    :seriesvalue="item.sales"
                    :Chartcolor="item.color"
                  />
                </td>
                <td>
                  <p class="text-muted mb-1">Participação</p>
                  <h5 class="mb-0">{{ item.sales }} %</h5>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
